import '../sass/mobile-app.scss';

/*
  Ce fichier est utilisé pour la gestion du changement de style pour les liens provenant des application mobiles. Le querystring
  nommé  contexte est utilisé pour détecter la provenance d'une telle  application mobile. Le cookie "contexte" est créer pour conserver
  ce style lors des changements de pages.
  Fonction lancer au load de la page pour ajouter une classe au tag body et cacher les menus
  param name: le nom du parametre
  réf: http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values
*/
$(document).ready(function() {
  
  //On créer le cookie au chargement de la page
  var contexte = getParameterByName("contexte");
  if(contexte) {
    createCookie("contexte",contexte,"14");
  }
  
  contexte = readCookie("contexte");
  if(contexte != null){
    document.body.className += ' ' + contexte;
    if(contexte.indexOf('app') == 0) {
      $('#ej-header h1').hide();
      $('#ej-content h1').hide();
      $('#ej-header #ej-home').hide();
      $('#ej-footer').hide();
    }
  }
  else{
    document.body.className += ' ' + "web_mobile_ej";
  }
});


/*
  Fonction pour créer un cookie
  param name: le nom du cookie
  param value: la valeur du cookie
  param days: nopmbre de jour avant l'expiration du cookie
  réf: http://www.quirksmode.org/js/cookies.html
*/
function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

/*
  Fonction pour lire un cookie
  param name: le nom du cookie
  réf: http://www.quirksmode.org/js/cookies.html
*/
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

/*
  Fonction pour supprimer un cookie
  param name: le nom du cookie
  réf: http://www.quirksmode.org/js/cookies.html
*/
function eraseCookie(name) {
  createCookie(name,"",-1);
}

/*
  Fonction pour extraire un query string du url
  param name: le nom du parametre
  réf: http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values
*/
function getParameterByName(name)
{
  name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.search);
  if(results == null)
    return "";
  else
    return decodeURIComponent(results[1].replace(/\+/g, " "));
}